import { InputHandler } from './InputHandler.js';
export class InputHandlerManager {
    constructor() {
        this._input_handlers = [];
    }
    create_input_handler(execution_object, interaction_objects) {
        const input_handler = new InputHandler(execution_object, interaction_objects);
        this._input_handlers.push(input_handler);
        input_handler.input_handler_disposed.add((_sender, _objects) => { this.remove_input_handler(input_handler, false); });
        return input_handler;
    }
    remove_input_handler(input_handler, call_dispose = true) {
        const index = this._input_handlers.indexOf(input_handler);
        if (index !== -1) {
            if (call_dispose)
                input_handler.dispose();
            this._input_handlers.splice(index, 1);
        }
    }
    interactable_is_pickable(interactable) {
        return this._input_handlers.some((input_handler) => input_handler.interaction_objects.includes(interactable) && input_handler.execution_object.has_input_handler);
    }
    count() {
        return this._input_handlers.length;
    }
    /**
     * Update/remove all input handlers that are associated with this object.
     * @param interactable The object to remove from the input handlers list.
     */
    remove_interactable(interactable) {
        /**
         * Notice: this might trigger a dispose or update observable while the list is still being iterated. If this causes
         * issues, could be changed so it notifies after the list has been updated.
         */
        for (let i = this._input_handlers.length - 1; i >= 0; i--) {
            const input_handler = this._input_handlers[i];
            if (input_handler.execution_object === interactable) {
                this._input_handlers.splice(i, 1);
                input_handler.dispose();
            }
            else {
                input_handler.remove_interaction_object(interactable);
            }
        }
    }
    get_execute_objects(interaction_object) {
        const execute_objects = [];
        for (let i = 0; i < this._input_handlers.length; i++) {
            const input_handler = this._input_handlers[i];
            if (input_handler.enabled && input_handler.interaction_objects.includes(interaction_object)) {
                execute_objects.push(input_handler.execution_object);
            }
        }
        return execute_objects;
    }
    to_string() {
        const get_object_id = (o) => 'id' in o ? '' + o.id : 'gizmo';
        let output = `InputHandlers[${this._input_handlers.length}]:`;
        this._input_handlers.forEach((ih, i) => {
            output += `\n    ${i}: ${get_object_id(ih.execution_object)} → ${ih.interaction_objects.map(get_object_id).join(', ')}`;
        });
        return output;
    }
}
//# sourceMappingURL=InputHandlerManager.js.map